import React from "react";
import BasicModal from "../../core/BaseComponents/Modal";

function WelcomeMessageCheckInOutModal(props) {
  const modalData = props?.isPublishedUnPublishedRef?.current?.isPublishUnPublishModalData;

  return (
    <BasicModal
      popupOpen={props?.publishUnPublishPopUp}
      logo={"/Images/approve-qc.png"}
      bodyMessage={<>
        {modalData && <p className="mt-2">{modalData?.message}</p>}
      </>
      }
      footer={
        modalData?.message === "Do you really want to Check-In?" ||
          modalData?.message === "Do you really want to Check-Out?" ? {
          primaryButton: {
            buttonName: "Cancel",
            action: props?.popupCloseHandler
          },
          secondaryButton: {
            buttonName: modalData?.row?.isPublished.toLowerCase() !== 'published' ? 'Check-In' : 'Check-Out',
            action: props?.publishUnPublishHandler
          }
        } : {
          secondaryButton: {
            buttonName: "OK",
            action: props?.popupCloseHandler
          }
        }
      }
    />
  );
}

export default WelcomeMessageCheckInOutModal;
